import cn from "classnames";
import React from "react";

const GroupByBidLogistFilter = (props) => {
    const toggleFilter = () => {
        props.setFilter({ name: "groupByBidLogist", value: !props.values.groupByBidLogist });
    };
    return (
        <div className="mb-md-0 report__filters--mr col-form-label-sm cursor-pointer" onClick={toggleFilter}>
            <i className={cn("checkbox d-inline-block mr-1", { "checkbox--checked": props.values.groupByBidLogist })} />
            Группировать по логисту заявки
        </div>
    );
};

export default GroupByBidLogistFilter;
